import {WorkspaceOccupancyState, mapiqApi} from '@lib/infrastructure';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {getIsOccupancyEnabled} from '../../infrastructure';

export const loadWorkspaceOccupancy = createAsyncThunk<WorkspaceOccupancyState[], string, AppThunkApiConfig>(
  'sensors/loadWorkspaceOccupancy',
  async (buildingId, {extra: {apiClient}, getState}) => {
    const state = getState();
    if (!getIsOccupancyEnabled(state)) {
      return [];
    }

    return mapiqApi(apiClient).getWorkspaceOccupancyStatesForBuilding(buildingId);
  },
  {
    condition: (buildingId, {getState}) => {
      const state = getState();
      const currentState = state.data.sensors.workspaceOccupancyByBuildingId[buildingId];

      if (currentState?.status === 'loading') {
        return false;
      }
    },
  },
);
